const autoNgTemplateLoaderTemplate1 = require('./nodeSelector.html');

import angular from 'angular';

import { NodeSelectorController } from './nodeSelectorController';

angular.module('shbdeployer.agent').component('nodeSelector', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: NodeSelectorController,
  bindings: {
    model: '=',
  },
});
